import { BehaviorSubject, Subscription } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';
import { SegmentService } from '@services/segment.service';
import { AuthorService } from '@services/author/author.service';

@Injectable({
  providedIn: 'root'
})
export class TrackingSegmentService implements OnDestroy {

  private subs: Subscription[] = [];
  private analystId: string;
  public dialogExportType: string;

  constructor(private segment: SegmentService) { }

  public identify(payload) {
    this.analystId = payload.user_id;
    this.subs.push(this.segment.identify(payload).subscribe());
  }

  public page(payload) {
    payload = {
      user_id: this.analystId,
      page_name: payload.page_name,
      url: payload.url,
      properties: payload.properties
    };
    this.subs.push(this.segment.page(payload).subscribe());
  }

  public track(title, properties) {
    const payload = {
      user_id: this.analystId,
      event_name: title,
      properties
    };
    this.subs.push(this.segment.track(payload).subscribe());
  }

  ngOnDestroy(): void {
    this.subs.forEach(subs => subs.unsubscribe());
  }

}
